import * as actionTypes from 'constants/action-types';
import { ServicesState } from 'store/services/servicesTypes';
import { FetchServicesAction } from 'store/services/servicesActionTypes';

const DEFAULT_STATE: ServicesState = {
  services: [],
  isLoading: true,
  lastUpdate: 0,
};

export const serviceReducer = (state: ServicesState = DEFAULT_STATE, action: FetchServicesAction): ServicesState => {
  switch (action.type) {
    case actionTypes.FETCH_SERVICES:
      return {
        ...state,
        isLoading: false,
        services: action.payload,
        lastUpdate: Date.now(),
      };
    default:
      return state;
  }
};
